export default "__VITE_ASSET__1e4e6361__"